import React, { Component } from "react";
import { getRecommendation } from "../helper/recommendation_helper";
import { renderErrorMessage } from "../helper/user_helper";
import Loader from "../components/loader";
import FullPageComments from "../components/recommendation/full_page_comments";
import FullPageRecommendation from "../components/recommendation/full_page_recommendation";

import MetaTags from "react-meta-tags";

class Recommendation extends Component {
  static contextTypes = {
    router: () => null // replace with PropTypes.object if you use them
  };

  state = { recommendation: null };

  constructor(props) {
    super(props);
    this.state = {
      recommendationId: props.match.params.id,
      recommendation: null,
      loaded: false,
      errors: "",
      selected_recommandation: null,
      windowHeight: window.innerHeight
    };
  }

  componentDidMount() {
    this.getRecommendationPage();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    if (this.recommendationCall) {
      this.recommendationCall.cancel();
    }
    this.setState({ windowHeight: window.innerHeight });
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    this.setState({ windowHeight: window.innerHeight });
    this.forceUpdate();
  };

  render() {
    return (
      <React.Fragment>
        <Loader loaded={this.state.loaded} />
        {renderErrorMessage(this.state.errors)}
        {this.renderRecommendation()}
      </React.Fragment>
    );
  }

  renderRecommendation() {
    if (this.state.recommendation === null) {
      return <div />;
    }

    if (this.state.selected_recommandation !== null) {
      return (
        <FullPageComments
          showFullPageComments={this.showFullPageComments}
          recommendation={this.state.selected_recommandation}
          updateCommentsNumber={this.updateCommentsNumber}
        />
      );
    }

    return (
      <div className="recommendation_full_page_only pt-5">
        <FullPageRecommendation
          can_delete={true}
          recommendation={this.state.recommendation}
          showFullPageComments={this.showFullPageComments}
          windowHeight={this.state.windowHeight}
          returnToProfilePage={this.returnToProfilePage}
        />
        {/* {this.renderMeta()} */}
        {this.renderNavBar()}
      </div>
    );
  }

  renderNavBar() {
    if (this.context.router.history.action === "PUSH") {
      return (
        <React.Fragment>
          <label
            className="yaystack_color yaystack_icon top_left cursor_btn"
            onClick={this.context.router.history.goBack}
          >
            <ion-icon name="ios-arrow-back" class="ion-icon" />
          </label>
        </React.Fragment>
      );
    }
    return (
      <React.Fragment>
        <label
          className="yaystack_color yaystack_icon top_left cursor_btn"
          onClick={this.returnToMainPage}
        >
          <ion-icon name="ios-arrow-back" class="ion-icon" />
        </label>
      </React.Fragment>
    );
  }

  renderMeta() {
    if (this.state.recommendation) {
      var imageUrl = "";
      if (this.state.recommendation.recommendation_type === "image") {
        imageUrl = this.state.recommendation.image_url_original;
      } else if (this.state.recommendation.recommendation_type === "video") {
        imageUrl = this.state.recommendation.video_url_image;
      }
      return (
        <MetaTags>
          <title>{this.state.recommendation.name}</title>
          <meta property="og:title" content="Yaystack" />
          <meta property="og:image" content={imageUrl} />
        </MetaTags>
      );
    }
    return <div />;
  }

  returnToMainPage = e => {
    this.props.history.push("/");
  };

  returnToProfilePage = e => {
    this.props.history.push("/profile");
  };

  getRecommendationPage() {
    const self = this;
    this.recommendationCall = getRecommendation(this.state.recommendationId, 1);
    this.recommendationCall.promise
      .then(answer => {
        const recommendation = answer.recommendation;
        const total_pages = answer.total_pages;
        const loaded = answer.loaded;
        const errors = answer.errors;
        const can_load_more = true;
        self.setState({
          recommendation,
          total_pages,
          loaded,
          errors,
          can_load_more
        });
      })
      .catch(errors => {
        self.returnToMainPage();
      });
  }

  showFullPageComments = recommendation => {
    this.setState({ selected_recommandation: recommendation });
  };

  updateCommentsNumber = (recommendation_, update) => {
    const recommendation = this.state.recommendation;
    if (update === "add") {
      recommendation.comment_number++;
    } else {
      recommendation.comment_number--;
    }
    this.setState({ recommendation });
  };
}

export default Recommendation;



// WEBPACK FOOTER //
// ./src/pages/recommendation.jsx